import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../api/client';
import { apiError } from './AdminSpvs';

const inr = (v) => `₹${Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const AdminResale = () => {
  const [rows, setRows] = useState(null);
  const [refs, setRefs] = useState([]);
  const load = useCallback(async () => {
    try {
      const [r, f] = await Promise.all([api.get('/api/admin/resale/'), api.get('/api/admin/referrals/')]);
      setRows(r.data); setRefs(f.data);
    } catch (e) { toast.error('Failed to load'); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, ok) => { try { await fn(); toast.success(ok); load(); } catch (e) { toast.error(apiError(e)); } };
  const approve = (l, i) => {
    const utr = window.prompt(`Approve transfer of ${l.shares} shares to ${i.name}.\nBuyer pays ${inr(l.buyer_pays)}. Enter the UTR of the funds received:`);
    if (utr) act(() => api.post(`/api/admin/resale/${l.id}/approve/`, { buyer: i.investor, buyer_utr: utr }), 'Transfer approved and register updated');
  };
  const sellerUtr = (l) => {
    const utr = window.prompt(`UTR of the payout of ${inr(l.seller_receives)} to ${l.seller}:`);
    if (utr) act(() => api.patch(`/api/admin/resale/${l.id}/`, { seller_utr: utr }), 'Recorded');
  };
  const payReferral = (r) => {
    const utr = window.prompt(`UTR of the ${inr(r.amount)} referral payout to ${r.referrer}:`);
    if (utr) act(() => api.patch(`/api/admin/referrals/${r.id}/`, { status: 'paid', utr }), 'Marked paid');
  };

  if (!rows) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  return (
    <main style={{ maxWidth: 1100, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>Resale and referrals</h1>
      <h2>Resale listings</h2>
      {rows.length === 0 ? <p>None.</p> : rows.map((l) => (
        <article key={l.id} style={{ border: '1px solid #ddd', borderRadius: 8, padding: 12, margin: '12px 0' }}>
          <strong>{l.spv_name}</strong> — {l.seller} · {l.shares} shares @ {inr(l.ask_price)} · {l.status}
          <div>Buyer pays {inr(l.buyer_pays)} · seller receives {inr(l.seller_receives)} · platform fee {inr(l.platform_fee)}</div>
          {l.status === 'open' && (l.interests.length === 0 ? <div>No interest yet.</div> : l.interests.map((i) => (
            <button key={i.investor} onClick={() => approve(l, i)} style={{ marginRight: 8 }}>Approve for {i.name}</button>
          )))}
          {l.status === 'completed' && <div>Buyer: {l.buyer} (UTR {l.buyer_utr}) · seller payout: {l.seller_utr || <button onClick={() => sellerUtr(l)}>Record payout</button>}</div>}
        </article>
      ))}
      <h2>Referral fees</h2>
      {refs.length === 0 ? <p>None yet. A fee is created when a referred investor's shares are allotted.</p> : (
        <table style={{ width: '100%' }}>
          <thead><tr><th align="left">Referrer</th><th align="left">Referred</th><th align="left">SPV</th><th align="right">Amount</th><th align="left">Status</th><th /></tr></thead>
          <tbody>{refs.map((r) => (
            <tr key={r.id}><td>{r.referrer}</td><td>{r.referred}</td><td>{r.spv_name}</td><td align="right">{inr(r.amount)}</td><td>{r.status}{r.paid_utr && ` (UTR ${r.paid_utr})`}</td>
              <td>{r.status === 'due' && <button onClick={() => payReferral(r)}>Mark paid</button>}</td></tr>
          ))}</tbody>
        </table>
      )}
    </main>
  );
};

export default AdminResale;
